module.exports = __webpack_public_path__ + "./img/empty-shoppingcart.ca28ffdd6e15635a422c5a15a210aea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty-shoppingcart.png
// module id = ./src/assets/img/empty-shoppingcart.png
// module chunks = 6